// Modals
export const DELETE_ACCOUNT_CONFIRMATION_MODAL =
  'delete-account-confirmation-modal'
export const DELETE_ACCOUNT_REJECTION_MODAL = 'delete-account-rejection-modal'
export const WARRANTY_WARNING_MODAL = 'warranty-warning-modal'

// Errors
export const WARRANTY_ERROR = 'Has orders under warranty'
